import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { PortalLayout } from "../components/portal/PortalLayout";
import { SRStatoBadge } from "../components/portal/SRForm";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Skeleton } from "../components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { formatDateTime } from "../lib/format";
import { PlusCircle, ClipboardList } from "lucide-react";

export default function PortalHome() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const load = useCallback(async () => {
    try { const { data } = await api.get("/portale/richieste"); setItems(data); } catch { setItems((s) => s || []); }
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, [load]);

  return (
    <PortalLayout>
      <div className="flex flex-wrap items-end justify-between gap-3 mb-6">
        <div>
          <h1 className="text-3xl font-bold font-heading text-slate-900 tracking-tight">Le tue richieste</h1>
          <p className="text-sm text-slate-500 mt-1">Stato aggiornato automaticamente: Ricevuta → Presa in carico → Assegnata.</p>
        </div>
        <Button data-testid="portal-new-request" className="gap-2" onClick={() => navigate("/strutture/nuova")}><PlusCircle className="h-4 w-4" /> Nuova richiesta</Button>
      </div>
      <Card className="border-slate-200 overflow-hidden">
        {items === null ? (
          <div className="p-5 space-y-3">{[...Array(4)].map((_, i) => <Skeleton key={`sk-${i}`} className="h-10 w-full" />)}</div>
        ) : items.length === 0 ? (
          <div data-testid="portal-empty" className="py-16 text-center">
            <ClipboardList className="h-10 w-10 mx-auto text-slate-300 mb-3" />
            <p className="text-sm text-slate-500">Nessuna richiesta inviata. Crea la prima con "Nuova richiesta".</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Codice</TableHead><TableHead>Paziente</TableHead><TableHead>Carico</TableHead>
                  <TableHead>Destinazione</TableHead><TableHead>Stato</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {items.map((r) => (
                  <TableRow key={r.id} data-testid={`portal-row-${r.id}`} className="cursor-pointer hover:bg-slate-50" onClick={() => navigate(`/strutture/richiesta/${r.id}`)}>
                    <TableCell className="font-mono text-xs font-bold text-primary">{r.code}</TableCell>
                    <TableCell className="text-sm font-medium text-slate-800">{r.paziente_nominativo}</TableCell>
                    <TableCell className="text-sm text-slate-600 whitespace-nowrap">{formatDateTime(r.data_ora_carico)}</TableCell>
                    <TableCell className="text-sm text-slate-600">{r.destinazione_nome || r.destinazione_indirizzo}</TableCell>
                    <TableCell><SRStatoBadge stato={r.stato} testid={`portal-stato-${r.id}`} /></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </Card>
    </PortalLayout>
  );
}
